import { useEffect, useRef } from 'react'

// Save previous render value
export default function usePrevious(value) {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}